import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { MODULE_ENTRY_COMPONENTS, DEFINE_CUSTOM_ELEMENTS } from './module-common';

@NgModule({
  entryComponents: MODULE_ENTRY_COMPONENTS
})
export class LocalBusinessNavElementsModule implements DoBootstrap {
  constructor(private injector: Injector) {
    DEFINE_CUSTOM_ELEMENTS(this.injector);
  }

  ngDoBootstrap(): void {
    // pass
  }
}
